import request from '@/utils/request'

const preUrl = "/news";
export const reqListNews = (data) => {
    return request({
        url: preUrl + '/list', method: 'post', data
    })
}
export const reqInsertNews = (data) => {
    return request({
        url: preUrl + '/insert', method: 'post', data
    })
}
export const reqUpdateNews = (data) => {
    return request({
        url: preUrl + '/update', method: 'post', data
    })
}
export const reqDeleteNews = (params) => {
    return request({
        url: preUrl + '/delete', method: 'get', params
    })
}
export const reqGetNewsDetail = (params) => {
    return request({
        url: preUrl + '/detail', method: 'get', params
    })
}
